import React from 'react';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { Box, Button, Typography } from '@mui/material';
import { createRoot } from 'react-dom/client';

export default function PdfGenerator(component, filename = 'document.pdf') {
    return new Promise((resolve, reject) => {
        const tempDiv = document.createElement('div');
        tempDiv.style.position = 'fixed';
        tempDiv.style.left = '-9999px';
        tempDiv.style.top = '0';
        tempDiv.style.width = '800px';
        tempDiv.style.backgroundColor = 'white';
        document.body.appendChild(tempDiv);
    
        const root = createRoot(tempDiv);
        root.render(component);
    
        setTimeout(() => {
          html2canvas(tempDiv)
            .then((canvas) => {
              const imgData = canvas.toDataURL('image/png');
              const doc = new jsPDF({ orientation: 'portrait', unit: 'px', format: 'a4' });
    
              const imgProps = doc.getImageProperties(imgData);
              const pdfWidth = doc.internal.pageSize.getWidth();
              const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
    
              doc.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
              doc.save(filename);
    
              root.unmount();
              document.body.removeChild(tempDiv);
              resolve();
            })
            .catch((error) => {
              root.unmount();
              document.body.removeChild(tempDiv);
              reject(error);
            });
        }, 300);
      });
}
